<template>
  <div>
    <h2 class="subtitle">
      {{ `${vending.catalog.length} / 6 ${$tc("vending.category", 2)}` }}

      <b-tooltip
        :label="$t('vending.addCategory')"
        position="is-right"
        v-if="!vendingBeingManaged.vendingInfo.isCacauShow"
      >
        <button
          class="button is-small"
          @click="addCategoryModalVisible = true"
          v-if="vending.catalog.length < 6"
        >
          <b-icon icon="plus-circle" type="is-primary"></b-icon>
        </button>
      </b-tooltip>
    </h2>

    <p v-if="vending.catalog.length === 0">
      {{ $t("vending.noCategories") }}
    </p>

    <div v-else>
      <category-card
        v-for="c in vending.catalog"
        :key="c._id"
        :category="c"
        :vending="vending"
        @update-vending="updateVending"
      />
    </div>

    <b-modal :active.sync="addCategoryModalVisible">
      <add-category-modal :vending="vending" @update-vending="updateVending" />
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import categoryCard from "./CategoryCard";
import addCategoryModal from "./AddCategoryModal";

export default {
  components: {
    categoryCard,
    addCategoryModal
  },

  data() {
    return {
      addCategoryModalVisible: false,
      vending: {
        _id: null,
        catalog: []
      }
    };
  },

  methods: {
    updateVending() {
      this.vending = this.vendingBeingManaged;
    }
  },

  computed: {
    ...mapGetters(["vendingBeingManaged"])
  },

  mounted() {
    this.updateVending();
  }
};
</script>
